import {getPrimaryAsset} from '@sollapay/domain/asset-types';

import type {BuyerTableRow} from '../types/buyers.types';
import type {ListSortConfig} from '@sollapay/ui/components';

export const BUYER_SORT_CONFIG: ListSortConfig<BuyerTableRow> = {
  order: [
    'createdAt',
    'fullName',
    'purchasePrice',
    'amountToPay',
    'depositPaid',
    'paymentStatus',
    'latestPaymentStatus',
    'asset'
  ],
  fields: {
    createdAt: {
      i18nKey: 'view.buyers.list.sorting.createdAt',
      defaultDesc: true,
      getValue: (row: BuyerTableRow) => new Date(row.buyers[0].createdAt).getTime()
    },
    fullName: {
      i18nKey: 'view.buyers.list.sorting.fullName',
      defaultDesc: false,
      getValue: (row: BuyerTableRow) => row.buyers[0].fullName
    },
    purchasePrice: {
      i18nKey: 'view.buyers.list.sorting.purchasePrice',
      defaultDesc: true,
      getValue: (row: BuyerTableRow) => Number(row.purchase.purchasePriceNis)
    },
    amountToPay: {
      i18nKey: 'view.buyers.list.sorting.amountToPay',
      defaultDesc: true,
      getValue: (row: BuyerTableRow) => Number(row.amountToPayNis)
    },
    depositPaid: {
      i18nKey: 'view.buyers.list.sorting.depositPaid',
      defaultDesc: true,
      getValue: (row: BuyerTableRow) => Number(row.depositPaidNis)
    },
    paymentStatus: {
      i18nKey: 'view.buyers.list.sorting.paymentStatus',
      defaultDesc: false,
      getValue: (row: BuyerTableRow) => row.paymentStatus
    },
    latestPaymentStatus: {
      i18nKey: 'view.buyers.list.sorting.latestPaymentStatus',
      defaultDesc: false,
      getValue: (row: BuyerTableRow) => row.latestInstruction?.status ?? ''
    },
    asset: {
      i18nKey: 'view.buyers.list.sorting.asset',
      defaultDesc: false,
      getValue: (row: BuyerTableRow) => getPrimaryAsset(row.purchase).displayCode
    }
  }
};
